__turbopack_context__.v({
  "complaint-warning": "RefundCalculation-module-scss-module__6YcVdG__complaint-warning",
  "divider": "RefundCalculation-module-scss-module__6YcVdG__divider",
  "dropdown-icon": "RefundCalculation-module-scss-module__6YcVdG__dropdown-icon",
  "dropdown-icon-collapsed": "RefundCalculation-module-scss-module__6YcVdG__dropdown-icon-collapsed",
  "receipt-container": "RefundCalculation-module-scss-module__6YcVdG__receipt-container",
  "receipt-header": "RefundCalculation-module-scss-module__6YcVdG__receipt-header",
  "receipt-name": "RefundCalculation-module-scss-module__6YcVdG__receipt-name",
  "receipt-value": "RefundCalculation-module-scss-module__6YcVdG__receipt-value",
  "receipt-wrapper": "RefundCalculation-module-scss-module__6YcVdG__receipt-wrapper",
  "receipts-wrapper": "RefundCalculation-module-scss-module__6YcVdG__receipts-wrapper",
  "receipts-wrapper-collapsible": "RefundCalculation-module-scss-module__6YcVdG__receipts-wrapper-collapsible",
  "receipts-wrapper-container": "RefundCalculation-module-scss-module__6YcVdG__receipts-wrapper-container",
  "total-price": "RefundCalculation-module-scss-module__6YcVdG__total-price",
  "total-price-gift-card": "RefundCalculation-module-scss-module__6YcVdG__total-price-gift-card",
  "total-price-header": "RefundCalculation-module-scss-module__6YcVdG__total-price-header",
  "total-price-sub-header": "RefundCalculation-module-scss-module__6YcVdG__total-price-sub-header",
});
